import { render } from "./treeOffCanvas.vue?vue&type=template&id=727974fe&scoped=true"
import script from "./treeOffCanvas.vue?vue&type=script&lang=js"
export * from "./treeOffCanvas.vue?vue&type=script&lang=js"

import "./treeOffCanvas.vue?vue&type=style&index=0&id=727974fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-727974fe"]])

export default __exports__